module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"no-cameras":"Камер нет","loading":"Загрузка данных"},"en":{"no-cameras":"No cameras","loading":"Data loading"}}')
  delete Component.options._Ctor
}
